import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import IoAndroidAdd from "react-icons/lib/io/android-add";
import { assetsPath } from "../utils";
import Image from "./Image";

const noImageAvailable = `${assetsPath(
  "phuket-laguna-village-residences"
)}/images/No_Image_Available.jpg`;

export default class ImagePlus extends PureComponent {
  static propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string
  };
  static defaultProps = {
    src: noImageAvailable,
    alt: process.env.REACT_APP_WEBSITE_NAME
  };
  renderTitle = (title) => <p style={{paddingLeft: 0, paddingTop: 10 }}>{title}</p>;
  render() {
    const { alt, src, title } = this.props;
    return (
      <div className="image-plus-container marginLeft">
        <div className="image-plus-content">
          <Image className="image-plus-item" src={src} alt={alt} />
          <div className="plus-arrow">
            <IoAndroidAdd className="icon-name" />
          </div>
        </div>
        { this.renderTitle(title) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImagePlus.js